import { Stack, Typography } from '@rossum/ui/material';

export const OptionValue = (props: { label: string; value: string }) => {
  return (
    <Stack width="100%">
      <Typography component="span" variant="body2" fontWeight="bold">
        {props.label}
      </Typography>
      <Typography component="span" variant="caption" fontFamily="monospace">
        {props.value}
      </Typography>
    </Stack>
  );
};
